import { httpService } from '../..';
import { IApiExecuteRespone } from '../apiInterfaces';
import { ApiUrls } from '../ApiUrls';
import { IAddress } from './addressInterfaces';

export async function UpdateAddressFromAxAddress(payload: {
  addressId: number;
  axRecId: number;
}): Promise<IApiExecuteRespone<IAddress[]>> {
  const response: IApiExecuteRespone<IAddress[]> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.axAddressUpdate(), payload);
    response.value = await apiResponse.json();
  } catch (error) {
    response.requestFailed = true;
    response.exception = error;
  }

  return response;
}

export async function updateAddress(address: IAddress): Promise<IAddress> {
  return timeout(address);
}

async function timeout<T>(returnVal: T, wait: number = 1000): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    setTimeout(() => {
      resolve(returnVal);
    }, wait);
  });
}
